import { Button as DesktopNextButton } from '@bfa/base-ui';
import { Box } from '@bfa/common-ui';
import { useClientConfiguration } from '@bfa/nextjs-common/hooks';
import React, { useEffect } from 'react';
import useBusinessConfiguration from '../../../../../../hooks/useBusinessConfiguration';
import { ONBOARDING_SECTION_EVENTS as EVENTS } from '../../../../../../utils/analytics/events';
import { ContentDescription, ContentFlex, ContentTitle, Image, ImageBox, TextBox, } from './Content.styled';
import EdgeCTA from './EdgeCTA';
import StepFooter from './StepFooter';
var Content = function (_a) {
    var mobile = _a.mobile, desktop = _a.desktop, title = _a.title, description = _a.description, edgeButtonText = _a.edgeButtonText, edgeLinkText = _a.edgeLinkText, onEdgeButtonClick = _a.onEdgeButtonClick, numberSteps = _a.numberSteps, currentStep = _a.currentStep, nextButtonText = _a.nextButtonText, onEdgeLinkClick = _a.onEdgeLinkClick;
    var trackEvent = useBusinessConfiguration().trackEvent;
    var client = useClientConfiguration();
    var isMobile = client.isMobile();
    var isEdge = !!edgeButtonText;
    useEffect(function () {
        if (currentStep <= 0) {
            trackEvent(EVENTS.VIEW_START_MODAL);
        }
        if (currentStep >= 1 && currentStep <= 5) {
            trackEvent({
                action: "Tour Step ".concat(currentStep.toString()),
                label: "Viewed Tour Step ".concat(currentStep),
            });
        }
    }, [currentStep, trackEvent]);
    return (React.createElement(Box, null,
        React.createElement(ContentFlex, null,
            React.createElement(ImageBox, null,
                React.createElement(Image, { images: [
                        {
                            src: mobile.src || '',
                            alt: mobile.alt || '',
                            width: 1,
                            height: 1,
                        },
                        null,
                        {
                            src: desktop.src || '',
                            alt: desktop.alt || '',
                            width: 1,
                            height: 1,
                        },
                    ], priority: true, objectFit: "contain", layout: "fill" })),
            React.createElement(TextBox, null,
                React.createElement(ContentTitle, null, title),
                React.createElement(ContentDescription, null, description),
                isEdge ? (React.createElement(EdgeCTA, { onEdgeButtonClick: onEdgeButtonClick, edgeButtonText: edgeButtonText, edgeLinkText: edgeLinkText, onEdgeLinkClick: onEdgeLinkClick, isMobile: isMobile })) : (!isMobile && (React.createElement(DesktopNextButton, { variant: "primary", small: true, onClick: onEdgeButtonClick }, nextButtonText))))),
        !isEdge && (React.createElement(StepFooter, { numberSteps: numberSteps, currentStep: currentStep, onEdgeButtonClick: onEdgeButtonClick, isMobile: isMobile }))));
};
export default Content;
